import { Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  deleteHandler: any;
  msg?: string;
  itemName?: string | null;
};

export function ModalConfirmDelete(props: Props): JSX.Element {
  return (
    <Modal show={props.show} onHide={() => props.handleShow(false)} centered>
      <form action="">
        <Modal.Body>
          {props.msg ? (
            <>Are you sure you want to {props.msg}?</>
          ) : props.itemName ? (
            <p>Are you sure you want to delete <span className="ghost-pill">{props.itemName}</span>?</p>
          ) : (
            <>Are you sure you want to delete?</>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-link text-site text-uppercase"
            onClick={() => props.handleShow(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-button btn btn-primary text-uppercase
						user-from-submit-btn"
            onClick={props.deleteHandler}
          >
            {props.msg ?? " Delete"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
